import { FormsV1 } from '@frontend/api-digital-forms';
import { DEFAULT_DFX_HTTP_OPTIONS } from '../../constants';

export const useGetWritebackCapabilities = (locationId: string) => {
  const { data, isLoading, isError } = FormsV1.Queries.useGetWritebackCapabilitiesV3Query({
    request: { companyId: locationId },
    options: { enabled: !!locationId },
    httpOptions: DEFAULT_DFX_HTTP_OPTIONS,
  });

  const writebackCapabilities = data?.sourceCapabilities ?? [];
  const hasWritebackIntegration = writebackCapabilities.length > 0;

  return { writebackCapabilities, hasWritebackIntegration, isLoading, isError };
};
